function view (path) {
  return () => import(/* webpackChunkName: '' */ '@/views/user/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const userRoutes = [
  {
    path: '/user/dashboard',
    component: view('Dashboard'),
    name: 'user.dashboard',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Dashboard',
          active: true
        }
      ]
    }
  },
  {
    path: '/user/my-requests',
    component: view('MyRequests'),
    name: 'user.my-requests',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'My Requests',
          active: true
        }
      ]
    }
  },
  {
    path: '/user/pending-approvals',
    component: view('PendingApprovals'),
    name: 'user.pending-approvals',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Pending Approvals',
          active: true
        }
      ]
    }
  },
  {
    path: '/user/reports/request-histories',
    component: view('RequestHistories'),
    name: 'user.report-request-histories',
    meta: {
      breadcrumb: [
        {
          text: 'Reports'
        },
        {
          text: 'Request Histories',
          active: true
        }
      ]
    }
  },
  {
    path: '/user/reports/approval-histories',
    component: view('ApprovalHistories'),
    name: 'user.report-approval-histories',
    meta: {
      breadcrumb: [
        {
          text: 'Reports'
        },
        {
          text: 'Approval Histories',
          active: true
        }
      ]
    }
  }
]

export default userRoutes
